import { render, staticRenderFns } from "./main.vue?vue&type=template&id=cecbdba4&scoped=true&"
import script from "./main.js?vue&type=script&lang=js&"
export * from "./main.js?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=cecbdba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecbdba4",
  null
  
)

export default component.exports